<template>
<Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Pays</h2>
    </div>
  </div>
  <CriteresRecherchePays @rechercher="rechercher"/>
  <ResultatRecherchePays :pays="pays" :isRechercheDataLoading="isRechercheDataLoading" @removePaysFromList="removePaysFromList"/>
</template>

<script>
import CriteresRecherchePays from '../../../../components/pilotage/ClassementDesVilles/Pays/CriteresRecherchePays.vue'
import ResultatRecherchePays from '../../../../components/pilotage/ClassementDesVilles/Pays/ResultatRecherchePays.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRecherchePays,
    ResultatRecherchePays
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Pays");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.rechercher();
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      pays: []
    }
  },
  methods: {
    rechercher() {
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'Pays').then((res) => {
        this.pays = res.data;
        this.isRechercheDataLoading = false;
      });
    },
    removePaysFromList(paysToRemove) {
      this.pays = this.pays.filter(current => (current.valeur != paysToRemove.valeur))
    }
  }
}
</script>
